import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./Projects.css";
import ProjectsInfo from "./ProjectsInfo";

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("projectData.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  // const settings = {
  //     className: "center",
  //     centerMode: true,
  //     infinite: true,
  //     centerPadding: "100px",
  //     autoplay: true,
  //     pauseOnHover: true,
  //     speed: 1000,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,

  //     responsive: [
  //         {
  //             breakpoint: 960,
  //             settings: {
  //                 slidesToShow: 2,
  //                 slidesToScroll: 1,
  //             },
  //         },
  //         {
  //             breakpoint: 768,
  //             settings: {
  //                 slidesToShow: 1,
  //                 slidesToScroll: 1,
  //             },
  //         },
  //         {
  //             breakpoint: 480,
  //             settings: {
  //                 slidesToShow: 1,
  //                 slidesToScroll: 1,
  //             },
  //         },
  //     ],
  // };

  return (
    <section id="projects">
      <Container>
        <div className="projects-heading">
          <div>
            <p className="section-kicker">
              <span /> Selected work
            </p>
            <h1>
              Projects &amp; <em>practice.</em>
            </h1>
          </div>
          <p className="projects-lead">A selection of interfaces and applications built to solve real problems.</p>
        </div>
        <div className="projects-grid" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1000">
          {projects.map((projectData) => (
            <ProjectsInfo key={projectData.id} projectData={projectData} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Projects;
